(function () {
  'use strict';

  var SCRIPT_SELECTOR = 'script[data-widget-id]';
  var WIDGET_ROOT_ID = 'bookimed-trust-widget';
  var CSS_FILE_NAME = 'trust-widget.css';
  var API_BASE = 'https://backoffice.bookimed.com/partner-widgets/clinic-widgets/trust';

  var SOURCE_NAMES = {
    google: 'Google',
    trustpilot: 'Trustpilot',
    bookimed: 'Bookimed'
  };

  // --- i18n -----------------------------------------------------------------
  // Keys mirror the Bookimed site locale codes (ua/jp/kz/... + pt-BR, th).
  // {source} = brand name (Google/Trustpilot/Bookimed), {count}/{link} = injected.
  var I18N = {
    en: { overall_rating: 'Overall rating', source_rating: '{source} rating', based_on: 'Based on {link}', reviews: '{count} reviews', all_reviews: 'All reviews', read_more: 'Read more', no_reviews: 'No reviews available.', powered_by: 'Powered by', loading: 'Loading reviews…', error_load: 'Unable to load reviews right now.', disabled: 'Widget is disabled.', missing_id: 'Widget ID is missing.', aria_filter: 'Filter reviews by source', aria_prev: 'Previous reviews', aria_next: 'Next reviews', aria_close: 'Close', aria_modal: 'Full review' },
    ru: { overall_rating: 'Общий рейтинг', source_rating: 'Рейтинг {source}', based_on: 'На основе {link}', reviews: '{count} отзывов', all_reviews: 'Все отзывы', read_more: 'Читать полностью', no_reviews: 'Отзывов пока нет.', powered_by: 'Работает на', loading: 'Загрузка отзывов…', error_load: 'Не удалось загрузить отзывы.', disabled: 'Виджет отключён.', missing_id: 'Не указан ID виджета.', aria_filter: 'Фильтр отзывов по источнику', aria_prev: 'Предыдущие отзывы', aria_next: 'Следующие отзывы', aria_close: 'Закрыть', aria_modal: 'Полный отзыв' },
    ar: { overall_rating: 'التقييم العام', source_rating: 'تقييم {source}', based_on: 'بناءً على {link}', reviews: '{count} تقييم', all_reviews: 'كل التقييمات', read_more: 'قراءة المزيد', no_reviews: 'لا توجد تقييمات متاحة.', powered_by: 'مدعوم من', loading: 'جارٍ تحميل التقييمات…', error_load: 'تعذّر تحميل التقييمات الآن.', disabled: 'الأداة معطّلة.', missing_id: 'معرّف الأداة مفقود.', aria_filter: 'تصفية التقييمات حسب المصدر', aria_prev: 'التقييمات السابقة', aria_next: 'التقييمات التالية', aria_close: 'إغلاق', aria_modal: 'التقييم الكامل' },
    ua: { overall_rating: 'Загальний рейтинг', source_rating: 'Рейтинг {source}', based_on: 'На основі {link}', reviews: '{count} відгуків', all_reviews: 'Усі відгуки', read_more: 'Читати повністю', no_reviews: 'Відгуків поки немає.', powered_by: 'Працює на', loading: 'Завантаження відгуків…', error_load: 'Не вдалося завантажити відгуки.', disabled: 'Віджет вимкнено.', missing_id: 'Не вказано ID віджета.', aria_filter: 'Фільтр відгуків за джерелом', aria_prev: 'Попередні відгуки', aria_next: 'Наступні відгуки', aria_close: 'Закрити', aria_modal: 'Повний відгук' },
    kz: { overall_rating: 'Жалпы рейтинг', source_rating: '{source} рейтингі', based_on: '{link} негізінде', reviews: '{count} пікір', all_reviews: 'Барлық пікірлер', read_more: 'Толық оқу', no_reviews: 'Әзірге пікірлер жоқ.', powered_by: 'Қолдау көрсетеді', loading: 'Пікірлер жүктелуде…', error_load: 'Пікірлерді жүктеу мүмкін болмады.', disabled: 'Виджет өшірілген.', missing_id: 'Виджет ID көрсетілмеген.', aria_filter: 'Пікірлерді дереккөз бойынша сүзу', aria_prev: 'Алдыңғы пікірлер', aria_next: 'Келесі пікірлер', aria_close: 'Жабу', aria_modal: 'Толық пікір' },
    jp: { overall_rating: '総合評価', source_rating: '{source}の評価', based_on: '{link}に基づく', reviews: '{count}件のレビュー', all_reviews: 'すべてのレビュー', read_more: '続きを読む', no_reviews: 'レビューはまだありません。', powered_by: '提供', loading: 'レビューを読み込んでいます…', error_load: '現在レビューを読み込めません。', disabled: 'ウィジェットは無効です。', missing_id: 'ウィジェットIDがありません。', aria_filter: 'ソースでレビューを絞り込む', aria_prev: '前のレビュー', aria_next: '次のレビュー', aria_close: '閉じる', aria_modal: 'レビュー全文' },
    it: { overall_rating: 'Valutazione complessiva', source_rating: 'Valutazione su {source}', based_on: 'Basato su {link}', reviews: '{count} recensioni', all_reviews: 'Tutte le recensioni', read_more: 'Leggi di più', no_reviews: 'Nessuna recensione disponibile.', powered_by: 'Offerto da', loading: 'Caricamento delle recensioni…', error_load: 'Impossibile caricare le recensioni al momento.', disabled: 'Widget disattivato.', missing_id: 'ID widget mancante.', aria_filter: 'Filtra le recensioni per fonte', aria_prev: 'Recensioni precedenti', aria_next: 'Recensioni successive', aria_close: 'Chiudi', aria_modal: 'Recensione completa' },
    es: { overall_rating: 'Valoración general', source_rating: 'Valoración de {source}', based_on: 'Basado en {link}', reviews: '{count} reseñas', all_reviews: 'Todas las reseñas', read_more: 'Leer más', no_reviews: 'No hay reseñas disponibles.', powered_by: 'Con tecnología de', loading: 'Cargando reseñas…', error_load: 'No se pueden cargar las reseñas ahora.', disabled: 'El widget está desactivado.', missing_id: 'Falta el ID del widget.', aria_filter: 'Filtrar reseñas por fuente', aria_prev: 'Reseñas anteriores', aria_next: 'Reseñas siguientes', aria_close: 'Cerrar', aria_modal: 'Reseña completa' },
    id: { overall_rating: 'Peringkat keseluruhan', source_rating: 'Peringkat {source}', based_on: 'Berdasarkan {link}', reviews: '{count} ulasan', all_reviews: 'Semua ulasan', read_more: 'Baca selengkapnya', no_reviews: 'Belum ada ulasan.', powered_by: 'Didukung oleh', loading: 'Memuat ulasan…', error_load: 'Tidak dapat memuat ulasan saat ini.', disabled: 'Widget dinonaktifkan.', missing_id: 'ID widget tidak ada.', aria_filter: 'Filter ulasan berdasarkan sumber', aria_prev: 'Ulasan sebelumnya', aria_next: 'Ulasan berikutnya', aria_close: 'Tutup', aria_modal: 'Ulasan lengkap' },
    de: { overall_rating: 'Gesamtbewertung', source_rating: '{source}-Bewertung', based_on: 'Basierend auf {link}', reviews: '{count} Bewertungen', all_reviews: 'Alle Bewertungen', read_more: 'Mehr lesen', no_reviews: 'Keine Bewertungen verfügbar.', powered_by: 'Bereitgestellt von', loading: 'Bewertungen werden geladen…', error_load: 'Bewertungen können derzeit nicht geladen werden.', disabled: 'Widget ist deaktiviert.', missing_id: 'Widget-ID fehlt.', aria_filter: 'Bewertungen nach Quelle filtern', aria_prev: 'Vorherige Bewertungen', aria_next: 'Nächste Bewertungen', aria_close: 'Schließen', aria_modal: 'Vollständige Bewertung' },
    fr: { overall_rating: 'Note globale', source_rating: 'Note {source}', based_on: 'Basé sur {link}', reviews: '{count} avis', all_reviews: 'Tous les avis', read_more: 'Lire la suite', no_reviews: 'Aucun avis disponible.', powered_by: 'Propulsé par', loading: 'Chargement des avis…', error_load: 'Impossible de charger les avis pour le moment.', disabled: 'Le widget est désactivé.', missing_id: 'ID du widget manquant.', aria_filter: 'Filtrer les avis par source', aria_prev: 'Avis précédents', aria_next: 'Avis suivants', aria_close: 'Fermer', aria_modal: 'Avis complet' },
    pl: { overall_rating: 'Ocena ogólna', source_rating: 'Ocena {source}', based_on: 'Na podstawie {link}', reviews: '{count} opinii', all_reviews: 'Wszystkie opinie', read_more: 'Czytaj więcej', no_reviews: 'Brak dostępnych opinii.', powered_by: 'Obsługiwane przez', loading: 'Ładowanie opinii…', error_load: 'Nie można teraz załadować opinii.', disabled: 'Widget jest wyłączony.', missing_id: 'Brak identyfikatora widżetu.', aria_filter: 'Filtruj opinie według źródła', aria_prev: 'Poprzednie opinie', aria_next: 'Następne opinie', aria_close: 'Zamknij', aria_modal: 'Pełna opinia' },
    'pt-BR': { overall_rating: 'Avaliação geral', source_rating: 'Avaliação do {source}', based_on: 'Com base em {link}', reviews: '{count} avaliações', all_reviews: 'Todas as avaliações', read_more: 'Ler mais', no_reviews: 'Nenhuma avaliação disponível.', powered_by: 'Desenvolvido por', loading: 'Carregando avaliações…', error_load: 'Não foi possível carregar as avaliações agora.', disabled: 'O widget está desativado.', missing_id: 'ID do widget ausente.', aria_filter: 'Filtrar avaliações por fonte', aria_prev: 'Avaliações anteriores', aria_next: 'Próximas avaliações', aria_close: 'Fechar', aria_modal: 'Avaliação completa' },
    th: { overall_rating: 'คะแนนโดยรวม', source_rating: 'คะแนนจาก {source}', based_on: 'อ้างอิงจาก {link}', reviews: '{count} รีวิว', all_reviews: 'รีวิวทั้งหมด', read_more: 'อ่านเพิ่มเติม', no_reviews: 'ยังไม่มีรีวิว', powered_by: 'ขับเคลื่อนโดย', loading: 'กำลังโหลดรีวิว…', error_load: 'ไม่สามารถโหลดรีวิวได้ในขณะนี้', disabled: 'วิดเจ็ตถูกปิดใช้งาน', missing_id: 'ไม่มี ID ของวิดเจ็ต', aria_filter: 'กรองรีวิวตามแหล่งที่มา', aria_prev: 'รีวิวก่อนหน้า', aria_next: 'รีวิวถัดไป', aria_close: 'ปิด', aria_modal: 'รีวิวฉบับเต็ม' }
  };

  var RTL_LANGS = { ar: true };

  // Site locale code -> BCP-47 tag for Intl.DateTimeFormat (date display).
  var INTL_LOCALE = {
    en: 'en', ru: 'ru', ar: 'ar', ua: 'uk', kz: 'kk', jp: 'ja', it: 'it',
    es: 'es', id: 'id', de: 'de', fr: 'fr', pl: 'pl', 'pt-BR': 'pt-BR', th: 'th'
  };

  // Site locale code -> language code expected by backoffice for fetching reviews.
  // Backoffice keys reviews by the SITE locale code for most locales (confirmed:
  // "ua" works as-is, NOT "uk"). Exception: Portuguese reviews are stored under
  // "pt", so "pt-BR" must be sent as "pt". If prod testing shows another locale
  // mismatched, adjust its value here.
  var REVIEW_LANG = {
    en: 'en', ru: 'ru', ar: 'ar', ua: 'ua', kz: 'kz', jp: 'jp', it: 'it',
    es: 'es', id: 'id', de: 'de', fr: 'fr', pl: 'pl', 'pt-BR': 'pt', th: 'th'
  };

  function normalizeLang(lang) {
    if (!lang) return 'en';
    var raw = String(lang).trim();
    if (I18N[raw]) return raw;
    var lower = raw.toLowerCase();
    var keys = Object.keys(I18N);
    var i;
    for (i = 0; i < keys.length; i += 1) {
      if (keys[i].toLowerCase() === lower) return keys[i];
    }
    var primary = lower.split('-')[0];
    for (i = 0; i < keys.length; i += 1) {
      if (keys[i].toLowerCase().split('-')[0] === primary) return keys[i];
    }
    return 'en';
  }

  function t(lang, key, params) {
    var d = I18N[normalizeLang(lang)] || I18N.en;
    var str = d[key] != null ? d[key] : (I18N.en[key] != null ? I18N.en[key] : key);
    if (params) {
      Object.keys(params).forEach(function (p) {
        str = str.split('{' + p + '}').join(params[p]);
      });
    }
    return str;
  }

  function intlLocale(lang) {
    return INTL_LOCALE[normalizeLang(lang)] || 'en';
  }

  function isRtl(lang) {
    return RTL_LANGS[normalizeLang(lang)] === true;
  }

  function reviewLang(lang) {
    var norm = normalizeLang(lang);
    return REVIEW_LANG[norm] || norm;
  }

  function sourceLabel(lang, source) {
    if (source === 'all') return t(lang, 'overall_rating');
    return t(lang, 'source_rating', { source: SOURCE_NAMES[source] || source });
  }

  var STAR_SVG = '<svg class="bookimed-trust-widget__star" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path></svg>';

  function getCurrentScript() {
    if (document.currentScript) {
      return document.currentScript;
    }
    var scripts = document.querySelectorAll(SCRIPT_SELECTOR);
    return scripts[scripts.length - 1] || null;
  }

  function loadCss(href) {
    if (!href || document.querySelector('link[data-bookimed-trust-widget-css="' + href + '"]')) {
      return;
    }
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.setAttribute('data-bookimed-trust-widget-css', href);
    document.head.appendChild(link);
  }

  function scriptBasePath(script) {
    try {
      return new URL('https://bookimed-assets.s3.eu-central-1.amazonaws.com/partners/widget/', script.src).href;
    } catch (error) {
      return '';
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatDate(value, lang) {
    if (!value) return '';
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;

    try {
      return new Intl.DateTimeFormat(intlLocale(lang), {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      }).format(date);
    } catch (error) {
      return value;
    }
  }

  function gradientForName(name) {
    var palette = [
      ['#f97316', '#ea580c'],
      ['#ec4899', '#db2777'],
      ['#3b82f6', '#2563eb'],
      ['#8b5cf6', '#7c3aed'],
      ['#10b981', '#059669'],
      ['#06b6d4', '#0891b2'],
      ['#a855f7', '#9333ea'],
      ['#eab308', '#ca8a04']
    ];
    var seed = 0;
    var input = String(name || 'A');
    for (var i = 0; i < input.length; i += 1) {
      seed += input.charCodeAt(i);
    }
    return palette[seed % palette.length];
  }

  function renderAvatar(review, size) {
    var safeName = escapeHtml(review.author || 'Anonymous');
    var rawName = String(review && review.author ? review.author : 'A');
    var dimensions = size || 40;
    var imageUrl = review && review.author_image_url ? String(review.author_image_url).trim() : '';
    var gradient = gradientForName(rawName);
    var initial = safeName.charAt(0).toUpperCase() || 'A';

    if (imageUrl) {
      return '<div class="bookimed-trust-widget__avatar" style="width:' + dimensions + 'px;height:' + dimensions + 'px;position:relative;overflow:hidden;background:linear-gradient(135deg,' + gradient[0] + ',' + gradient[1] + ');font-size:' + Math.round(dimensions * 0.4) + 'px;font-family:var(--tw-font-body);">' +
        '<span style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;">' + initial + '</span>' +
        '<img src="' + escapeHtml(imageUrl) + '" alt="' + safeName + '" style="position:relative;z-index:1;width:100%;height:100%;object-fit:cover;border-radius:50%;display:block;" onerror="this.remove()" />' +
        '</div>';
    }

    return '<div class="bookimed-trust-widget__avatar" style="width:' + dimensions + 'px;height:' + dimensions + 'px;background:linear-gradient(135deg,' + gradient[0] + ',' + gradient[1] + ');font-size:' + Math.round(dimensions * 0.4) + 'px;font-family:var(--tw-font-body);">' + initial + '</div>';
  }

  function renderStars(rating) {
    var count = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    return new Array(count + 1).join(STAR_SVG);
  }

  function getSourceIcon(source) {
    if (source === 'trustpilot') {
      return '<svg class="bookimed-trust-widget__source-icon" viewBox="0 0 24 24" fill="#00B67A" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path></svg>';
    }
    if (source === 'bookimed') {
      return '<svg class="bookimed-trust-widget__source-icon" viewBox="0 0 24 24" fill="#0A7B3F" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"></path></svg>';
    }
    return '<svg class="bookimed-trust-widget__source-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"></path><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"></path><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"></path><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"></path></svg>';
  }

  function getLabelIcon(source) {
    if (source === 'google' || source === 'trustpilot' || source === 'bookimed') {
      return '<span class="bookimed-trust-widget__overall-label-icon">' + getSourceIcon(source) + '</span>';
    }
    return '';
  }

  function resolveConfig(script) {
    return {
      widgetId: script.getAttribute('data-widget-id') || '',
      lang: script.getAttribute('data-widget-lang') || 'en',
      debug: script.getAttribute('data-debug') === 'true'
    };
  }

  function buildEndpoint(config) {
    return API_BASE + '/' + encodeURIComponent(reviewLang(config.lang)) + '/' + encodeURIComponent(config.widgetId);
  }

  function fetchWidgetData(config) {
    var endpoint = buildEndpoint(config);

    return fetch(endpoint, {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('HTTP ' + response.status);
      }
      return response.json();
    });
  }

  function normalizeSourceMap(items) {
    var result = {};

    (Array.isArray(items) ? items : []).forEach(function (item) {
      if (!item || !item.type) return;

      result[item.type] = {
        type: item.type,
        rating: Number(item.rating || 0),
        reviews_count: Number(item.reviews_count || 0),
        url: item.url || '',
        is_active: item.is_active !== false
      };
    });

    return result;
  }

  function reviewHasText(review) {
    return Boolean(review && typeof review.text === 'string' && review.text.trim());
  }

  function normalizeReviews(items) {
    return (Array.isArray(items) ? items : []).filter(function (review) {
      return reviewHasText(review);
    });
  }

  function countReviewsWithText(reviews, source) {
    return reviews.filter(function (review) {
      if (!reviewHasText(review)) return false;
      if (!source) return true;
      return review.source === source;
    }).length;
  }

  function countOverallFromSources(sourceMap) {
    var totalCount = 0;
    var weightedRating = 0;

    Object.keys(sourceMap).forEach(function (key) {
      var item = sourceMap[key];
      if (!item || item.is_active === false) return;

      var count = Number(item.reviews_count || 0);
      var rating = Number(item.rating || 0);

      totalCount += count;
      weightedRating += rating * count;
    });

    return {
      count: totalCount,
      rating: totalCount ? (weightedRating / totalCount) : 0
    };
  }

  function normalizeData(raw) {
    var settings = raw && raw.settings ? raw.settings : {};
    var clinic = raw && raw.clinic ? raw.clinic : {};
    var sourceMap = normalizeSourceMap(raw && raw.sources ? raw.sources : []);
    var reviews = normalizeReviews(raw && raw.reviews ? raw.reviews : []);

    var enabledSources = Object.keys(sourceMap).filter(function (key) {
      return sourceMap[key] && sourceMap[key].is_active !== false;
    });
    var overall = countOverallFromSources(sourceMap);

    return {
      id: raw && raw.id ? raw.id : '',
      settings: {
        clinic_id: settings.clinic_id,
        title: settings.title || '',
        link: settings.link || '',
        is_active: settings.is_active !== false,
        sources: Array.isArray(settings.sources) ? settings.sources : [],
        filters: settings.filters || {},
        styles: settings.styles || {}
      },
      clinic: {
        id: clinic.id,
        agency_id: clinic.agency_id,
        name: clinic.name || '',
        alias: clinic.alias,
        rating: clinic.rating,
        review_count: clinic.review_count,
        activated_at: clinic.activated_at,
        is_active: clinic.is_active
      },
      sources: sourceMap,
      overall: overall,
      single_source: enabledSources.length <= 1,
      reviews: reviews
    };
  }

  function applyStyles(root, styles) {
    if (!styles) return;

    if (styles.max_width) root.style.setProperty('--tw-max-width', styles.max_width);
    if (styles.color_bg) root.style.setProperty('--tw-color-bg', styles.color_bg);
    if (styles.color_card) root.style.setProperty('--tw-color-card', styles.color_card);
    if (styles.color_text) root.style.setProperty('--tw-color-text', styles.color_text);
    if (styles.color_text_muted) root.style.setProperty('--tw-color-text-muted', styles.color_text_muted);
    if (styles.color_primary) root.style.setProperty('--tw-color-primary', styles.color_primary);
    if (styles.color_border) root.style.setProperty('--tw-color-border', styles.color_border);
    if (styles.title_color) root.style.setProperty('--tw-color-title', styles.title_color);
    if (styles.container_padding) {
      root.style.setProperty('--tw-container-padding', styles.container_padding);
    }
    if (styles.font_family) {
      root.style.setProperty('--tw-font-family', styles.font_family);
    }
    if (styles.border_radius) {
      root.style.setProperty('--tw-radius', styles.border_radius);
      root.style.setProperty('--tw-radius-lg', styles.border_radius);
    }
  }

  function getEnabledSources(data) {
    return Object.keys(data.sources || {}).filter(function (key) {
      var item = data.sources[key] || {};
      return item.is_active !== false;
    });
  }

  function preservePoweredLink(root) {
    return root.querySelector('.bookimed-trust-link');
  }

  function resetRootKeepPoweredLink(root) {
    root.className = '';
    root.innerHTML = '';
  }

  function renderStatus(root, type, message) {
    var poweredLink = preservePoweredLink(root);
    var poweredHtml = '';

    if (poweredLink) {
      poweredHtml = poweredLink.outerHTML;
    }

    resetRootKeepPoweredLink(root);
    root.insertAdjacentHTML(
      'afterbegin',
      '<div class="bookimed-trust-widget">' +
      '<div class="bookimed-trust-widget__' + type + '">' + escapeHtml(message) + '</div>' +
      poweredHtml +
      '</div>'
    );
  }

  function createMarkup(root, data, lang) {
    var poweredLink = preservePoweredLink(root);
    var poweredHref = poweredLink
      ? (poweredLink.getAttribute('href') || '#')
      : (data.settings.link || '#');
    var poweredHtml = '<a href="' + escapeHtml(poweredHref) + '" class="bookimed-trust-link" target="_blank" rel="noopener" style="font-size:12px;color:#64748B;text-align:center;display:block;margin:8px 0;">' +
      escapeHtml(t(lang, 'powered_by')) + ' <span class="bookimed-trust-link__brand">Bookimed</span>' +
      '</a>';

    resetRootKeepPoweredLink(root);

    root.insertAdjacentHTML('afterbegin', [
      '<div class="bookimed-trust-widget">',
      '<div class="bookimed-trust-widget__inner">',
      (data.settings.title ? '<h2 class="bookimed-trust-widget__title">' + escapeHtml(data.settings.title) + '</h2>' : ''),
      '<div class="bookimed-trust-widget__tabs" role="tablist" aria-label="' + escapeHtml(t(lang, 'aria_filter')) + '"></div>',
      '<div class="bookimed-trust-widget__content">',
      '<div class="bookimed-trust-widget__overall">',
      '<div class="bookimed-trust-widget__overall-score"></div>',
      '<div class="bookimed-trust-widget__overall-meta">',
      '<div class="bookimed-trust-widget__overall-label"></div>',
      '<div class="bookimed-trust-widget__stars"></div>',
      '<div class="bookimed-trust-widget__count"></div>',
      '</div>',
      '</div>',
      '<div class="bookimed-trust-widget__carousel-wrapper">',
      '<div class="bookimed-trust-widget__carousel"></div>',
      '</div>',
      '</div>',
      '<div class="bookimed-trust-widget__nav">',
      '<button type="button" class="bookimed-trust-widget__nav-btn bookimed-trust-widget__nav-btn--prev" aria-label="' + escapeHtml(t(lang, 'aria_prev')) + '" disabled>',
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>',
      '</button>',
      '<button type="button" class="bookimed-trust-widget__nav-btn bookimed-trust-widget__nav-btn--next" aria-label="' + escapeHtml(t(lang, 'aria_next')) + '">',
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>',
      '</button>',
      '</div>',
      poweredHtml,
      '<div class="bookimed-trust-widget__modal-overlay" aria-hidden="true" role="dialog" aria-label="' + escapeHtml(t(lang, 'aria_modal')) + '">',
      '<div class="bookimed-trust-widget__modal">',
      '<button type="button" class="bookimed-trust-widget__modal-close" aria-label="' + escapeHtml(t(lang, 'aria_close')) + '">',
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
      '</button>',
      '<div class="bookimed-trust-widget__modal-author"></div>',
      '<div class="bookimed-trust-widget__modal-stars"></div>',
      '<div class="bookimed-trust-widget__modal-text"></div>',
      '</div>',
      '</div>',
      '</div>',
      '</div>'
    ].join(''));
  }

  function mountWidget(root, data, lang) {
    var state = {
      data: data,
      activeSource: 'all',
      currentIndex: 0,
      touchStartX: 0
    };

    var enabledSources = getEnabledSources(data);
    if (data.single_source && enabledSources.length === 1) {
      state.activeSource = enabledSources[0];
    }

    createMarkup(root, data, lang);
    applyStyles(root, data.settings.styles);
    root.setAttribute('dir', isRtl(lang) ? 'rtl' : 'ltr');

    var tabsEl = root.querySelector('.bookimed-trust-widget__tabs');
    var overallScoreEl = root.querySelector('.bookimed-trust-widget__overall-score');
    var overallLabelEl = root.querySelector('.bookimed-trust-widget__overall-label');
    var overallStarsEl = root.querySelector('.bookimed-trust-widget__stars');
    var overallCountEl = root.querySelector('.bookimed-trust-widget__count');
    var carouselEl = root.querySelector('.bookimed-trust-widget__carousel');
    var prevBtn = root.querySelector('.bookimed-trust-widget__nav-btn--prev');
    var nextBtn = root.querySelector('.bookimed-trust-widget__nav-btn--next');
    var modalOverlay = root.querySelector('.bookimed-trust-widget__modal-overlay');
    var modalAuthor = root.querySelector('.bookimed-trust-widget__modal-author');
    var modalStars = root.querySelector('.bookimed-trust-widget__modal-stars');
    var modalText = root.querySelector('.bookimed-trust-widget__modal-text');
    var modalClose = root.querySelector('.bookimed-trust-widget__modal-close');

    function getVisibleCards() {
      return window.innerWidth <= 768 ? 1 : 3;
    }

    function getFilteredReviews() {
      return state.activeSource === 'all'
        ? data.reviews.slice()
        : data.reviews.filter(function (review) { return review.source === state.activeSource; });
    }

    function getSidebarData() {
      if (state.activeSource === 'all') {
        return {
          rating: data.overall.rating,
          count: data.overall.count,
          url: data.settings.link || '#',
          label: sourceLabel(lang, 'all'),
          source: 'all'
        };
      }

      var sourceInfo = data.sources[state.activeSource] || {};
      return {
        rating: sourceInfo.rating,
        count: sourceInfo.reviews_count,
        url: sourceInfo.url || data.settings.link || '#',
        label: sourceLabel(lang, state.activeSource),
        source: state.activeSource
      };
    }

    function updateSidebar() {
      var sidebar = getSidebarData();
      overallScoreEl.textContent = sidebar.rating != null ? Number(sidebar.rating).toFixed(1) : '0.0';
      overallLabelEl.innerHTML = getLabelIcon(sidebar.source) + escapeHtml(sidebar.label);
      overallStarsEl.innerHTML = renderStars(sidebar.rating);
      var reviewsLink = '<a href="' + escapeHtml(sidebar.url) + '" target="_blank" rel="noopener">' + t(lang, 'reviews', { count: escapeHtml(sidebar.count || 0) }) + '</a>';
      overallCountEl.innerHTML = t(lang, 'based_on', { link: reviewsLink });
    }

    function renderTabs() {
      if (data.single_source || enabledSources.length <= 1) {
        tabsEl.classList.add('bookimed-trust-widget__hidden');
        return;
      }

      var allTab = '<button type="button" class="bookimed-trust-widget__tab' + (state.activeSource === 'all' ? ' is-active' : '') + '" role="tab" aria-selected="' + (state.activeSource === 'all' ? 'true' : 'false') + '" data-source="all">' + escapeHtml(t(lang, 'all_reviews')) + '</button>';
      var sourceTabs = enabledSources.map(function (key) {
        var info = data.sources[key] || {};
        return '<button type="button" class="bookimed-trust-widget__tab' + (state.activeSource === key ? ' is-active' : '') + '" role="tab" aria-selected="' + (state.activeSource === key ? 'true' : 'false') + '" data-source="' + escapeHtml(key) + '">' +
          '<span class="bookimed-trust-widget__tab-icon">' + getSourceIcon(key) + '</span>' +
          escapeHtml((SOURCE_NAMES[key] || key) + ' - ' + Number(info.rating || 0).toFixed(1)) + ' <span class="bookimed-trust-widget__tab-star">★</span>' +
          '</button>';
      }).join('');
      tabsEl.innerHTML = allTab + sourceTabs;

      Array.prototype.forEach.call(tabsEl.querySelectorAll('.bookimed-trust-widget__tab'), function (tab) {
        tab.addEventListener('click', function () {
          var nextSource = tab.getAttribute('data-source') || 'all';
          if (state.activeSource === nextSource) return;
          state.activeSource = nextSource;
          state.currentIndex = 0;
          renderTabs();
          updateSidebar();
          renderCards();
          updateCarousel();
        });
      });
    }

    function openModal(review) {
      modalAuthor.innerHTML = [
        renderAvatar(review, 40),
        '<div class="bookimed-trust-widget__author-info">',
        '<div class="bookimed-trust-widget__author-name-row">',
        '<span class="bookimed-trust-widget__author-name">' + escapeHtml(review.author || 'Anonymous') + '</span>',
        '</div>',
        '<div class="bookimed-trust-widget__author-meta">',
        getSourceIcon(review.source),
        '<span>' + escapeHtml(formatDate(review.date, lang)) + '</span>',
        '</div>',
        '</div>'
      ].join('');
      modalStars.innerHTML = renderStars(review.rating);
      modalText.textContent = review.text || '';
      modalOverlay.classList.add('is-open');
      modalOverlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      modalClose.focus();
    }

    function closeModal() {
      modalOverlay.classList.remove('is-open');
      modalOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function renderCards() {
      var reviews = getFilteredReviews();
      var textTruncateLength = 180;

      if (!reviews.length) {
        carouselEl.innerHTML = '<div class="bookimed-trust-widget__empty">' + escapeHtml(t(lang, 'no_reviews')) + '</div>';
        prevBtn.disabled = true;
        nextBtn.disabled = true;
        return;
      }

      carouselEl.innerHTML = reviews.map(function (review, index) {
        var isTruncated = String(review.text || '').length > textTruncateLength;
        return '<article class="bookimed-trust-widget__card' + (isTruncated ? ' is-truncated' : '') + '" data-review-index="' + index + '">' +
          '<div class="bookimed-trust-widget__author">' +
          renderAvatar(review, 40) +
          '<div class="bookimed-trust-widget__author-info">' +
          '<div class="bookimed-trust-widget__author-name-row">' +
          '<span class="bookimed-trust-widget__author-name">' + escapeHtml(review.author || 'Anonymous') + '</span>' +
          '</div>' +
          '<div class="bookimed-trust-widget__author-meta">' + getSourceIcon(review.source) + '<span>' + escapeHtml(formatDate(review.date, lang)) + '</span></div>' +
          '</div>' +
          '</div>' +
          '<div class="bookimed-trust-widget__review-stars">' + renderStars(review.rating) + '</div>' +
          '<div class="bookimed-trust-widget__review-text">' + escapeHtml(review.text || '') + '</div>' +
          (isTruncated ? '<button type="button" class="bookimed-trust-widget__read-more">' + escapeHtml(t(lang, 'read_more')) + '</button>' : '') +
          '</article>';
      }).join('');

      Array.prototype.forEach.call(carouselEl.querySelectorAll('.bookimed-trust-widget__read-more'), function (button) {
        button.addEventListener('click', function (event) {
          var card = event.target.closest('.bookimed-trust-widget__card');
          var index = Number(card && card.getAttribute('data-review-index'));
          var items = getFilteredReviews();
          if (!Number.isNaN(index) && items[index]) {
            openModal(items[index]);
          }
        });
      });
    }

    function getMaxIndex() {
      var cards = carouselEl.querySelectorAll('.bookimed-trust-widget__card');
      return Math.max(0, cards.length - getVisibleCards());
    }

    function updateCarousel() {
      var cards = carouselEl.querySelectorAll('.bookimed-trust-widget__card');
      if (!cards.length) return;
      var cardWidth = cards[0].offsetWidth + 16;
      carouselEl.style.transform = 'translateX(-' + (state.currentIndex * cardWidth) + 'px)';
      prevBtn.disabled = state.currentIndex <= 0;
      nextBtn.disabled = state.currentIndex >= getMaxIndex();
    }

    prevBtn.addEventListener('click', function () {
      if (state.currentIndex > 0) {
        state.currentIndex -= 1;
        updateCarousel();
      }
    });

    nextBtn.addEventListener('click', function () {
      if (state.currentIndex < getMaxIndex()) {
        state.currentIndex += 1;
        updateCarousel();
      }
    });

    carouselEl.addEventListener('touchstart', function (event) {
      state.touchStartX = event.changedTouches[0].screenX;
    }, { passive: true });

    carouselEl.addEventListener('touchend', function (event) {
      var diff = state.touchStartX - event.changedTouches[0].screenX;
      if (Math.abs(diff) <= 50) return;
      if (diff > 0 && state.currentIndex < getMaxIndex()) {
        state.currentIndex += 1;
        updateCarousel();
      }
      if (diff < 0 && state.currentIndex > 0) {
        state.currentIndex -= 1;
        updateCarousel();
      }
    }, { passive: true });

    modalClose.addEventListener('click', closeModal);
    modalOverlay.addEventListener('click', function (event) {
      if (event.target === modalOverlay) closeModal();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modalOverlay.classList.contains('is-open')) {
        closeModal();
      }
    });

    window.addEventListener('resize', function () {
      if (state.currentIndex > getMaxIndex()) {
        state.currentIndex = getMaxIndex();
      }
      updateCarousel();
    });

    renderTabs();
    updateSidebar();
    renderCards();
    updateCarousel();
  }

  function renderWidget(root, response, options) {
    var lang = (options && options.lang) || 'en';
    var data = normalizeData(response);

    if (!data.settings || data.settings.is_active === false) {
      renderStatus(root, 'status', t(lang, 'disabled'));
      return;
    }

    mountWidget(root, data, lang);
  }

  function init() {
    var script = getCurrentScript();
    if (!script) return;

    var root = document.getElementById(WIDGET_ROOT_ID);
    if (!root) return;

    var config = resolveConfig(script);
    var basePath = scriptBasePath(script);

    root.setAttribute('dir', isRtl(config.lang) ? 'rtl' : 'ltr');

    if (!config.widgetId) {
      renderStatus(root, 'error', t(config.lang, 'missing_id'));
      return;
    }

    loadCss(basePath + CSS_FILE_NAME);

    renderStatus(root, 'status', t(config.lang, 'loading'));

    fetchWidgetData(config)
      .then(function (response) {
        renderWidget(root, response, { lang: config.lang });
      })
      .catch(function (error) {
        if (config.debug && window.console) {
          console.error('Bookimed Trust Widget error:', error);
        }
        renderStatus(root, 'error', t(config.lang, 'error_load'));
      });
  }

  window.BookimedTrustWidget = window.BookimedTrustWidget || {};
  window.BookimedTrustWidget.render = renderWidget;
  window.BookimedTrustWidget.loadCss = loadCss;
  window.BookimedTrustWidget.reviewLang = reviewLang;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
